export const projects = [
  {
    title: "HoloSign - Meta Quest 3",
    subtitle: "Mixed Reality Experience - XR Hackathon Winner",
    description:
      "Learn Sign Language through an interactive tutorial, then immerse yourself in a simulated chess game where you control pieces using sign language. Built with Unity (Gameplay) and PyTorch (ML)",
    image: "./holosign-logo.png",
    link: "https://www.youtube.com/watch?v=WVROteQhbcY",
  },
  {
    title: "Virtual Pet - Meta Quest 3",
    subtitle: "Mixed Reality Experience",
    description:
      "What if you could bring a virtual dog to your home in mixed reality? This prototype shows what it would be like to have a Golden Retriever at home. Built with Unity, C# and used Anything World for animation.",
    image: "./PetMR2.png",
    link: "https://www.youtube.com/shorts/nVz7zxl1Awo",
  },
  {
    title: "Shapion",
    subtitle: "iOS & Android Game",
    description:
      "Shapion is  a 2D game which challenges players to control a bird, using controls to collect coins for 1 point and defeat enemies for 2 points when larger. Built on Unity, Published on iOS & Android, 1K+ downloads.",
    image: "./shapion.png",
    link: "https://apps.apple.com/us/app/shapion/id6471966052",
  },
  {
    title: "Introduction Email Generator",
    subtitle: "LLM-Powered Web Application",
    description:
      "Crafting the perfect introduction email can be a tedious task, but with the Introduction Email Generator, people can create a customizable template in just a few seconds. This is one of the use cases for which people use LLM the most. Built with ReactJS, 300+ users.",
    image: "./generate-intro-email.png",
    link: "https://generate-intro-email.vercel.app",
  },
  {
    title: "Nature's Contributions to People",
    subtitle: "Data Visualization - Presented at Stanford University",
    description:
    "This project underscores the profound decline in pollination contributions since 1850 and investigates the potential ramifications for different continents. It won the award for the best project at EPFL and was subsequently showcased at the Stanford University's Natural Capital Project symposium in March 2019.",    
    image: "./data-viz.png",
    link: "https://charlottegiseleweil.github.io/natureforpeople/index.html",
  },
  {
    title: "The Resurrection of Cthulhu",
    subtitle: "WebGL Game - Junction Hackathon",
    description:
      "The Resurrection of Ctulhu, a captivating 2D puzzle game, emerged during Europe's largest Hackathon, Junction 2016. In this imaginative adventure, players are on a mission to revive the legendary Cthulhu by restoring his eight legs, presenting an engaging challenge. Built using the Unity game engine.",
    image: "./resurrection.png",
    link: "https://ahmedahres.itch.io/the-resurrection-of-cthulhu",
  },
  {
    title: "Planet Collisions",
    subtitle: "3D Animation",
    description:
      "3D Animation showing two colliding planets. Built on Blender.",
    image: "./animation.png",
    link: "https://www.youtube.com/watch?v=32pIFao5GZY",
  },
];



// WEBPACK FOOTER //
// ./src/data.js